//#region Table
export const columnList = [
    {field: 'name', header: 'Name', initialShown: true},
    {field: 'description', header: 'Description', initialShown: true},
    {
        field: 'icon',
        header: 'Icon',
        initialShown: true,
        body: rowData => (
            <div className="w-min border-round-lg bg-gray-50 p-1">
                <img
                    src={rowData?.icon}
                    height={30}
                    width={30}
                    alt={'pathway-img'}
                />
            </div>
        ),
    },
    {field: 'createdAt', header: 'Created At', initialShown: true},
]
//#endregion
